import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function Hero() {
  const { t } = useTranslation();
  const [selectedCategory, setSelectedCategory] = useState('');

  const handleDropdownChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    if (url) {
      setSelectedCategory(url);
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <section className="relative w-full min-h-screen flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Clean%20minimal%20product%20sourcing%20workspace%20with%20laptop%20and%20product%20samples%20on%20light%20cream%20desk%2C%20soft%20natural%20daylight%20from%20window%2C%20scandinavian%20aesthetic%2C%20warm%20neutral%20tones%2C%20elegant%20editorial%20photography%2C%20professional%20atmosphere%2C%20textile%20samples%20and%20catalog%20visible%2C%20no%20text%20no%20watermark&width=1800&height=1200&seq=hero-bg-main-01&orientation=landscape)`,
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>

      <div className="relative z-10 w-full px-6 md:px-10 pt-24 pb-16">
        <div className="flex flex-col lg:flex-row items-start gap-12 lg:gap-20 max-w-6xl mx-auto">
          <div className="flex-1 w-full pt-8 md:pt-16">
            <span className="inline-block text-xs tracking-widest uppercase text-white/80 mb-4 font-label">
              {t('hero_label')}
            </span>

            <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white leading-tight mb-6">
              {t('hero_title_line1')}
              <br />
              <span className="italic text-primary-300">{t('hero_title_line2')}</span>
            </h1>

            <p className="text-white/70 text-sm md:text-base max-w-lg mb-8 leading-relaxed">
              {t('hero_subtitle')}
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-10">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 bg-primary-500 text-background-50 px-8 py-3.5 rounded-full text-sm font-medium hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
              >
                <span>{t('btn_yoybuy_sheet')}</span>
                <i className="ri-arrow-right-up-line"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 border-2 border-white/40 text-white px-8 py-3.5 rounded-full text-sm font-medium hover:bg-white/15 transition-all whitespace-nowrap cursor-pointer"
              >
                <span>{t('btn_buy_now')}</span>
                <i className="ri-shopping-bag-line"></i>
              </a>
            </div>

            <div className="relative w-full max-w-md">
              <label className="block text-white/70 text-xs mb-2 font-label tracking-wide">
                {t('dropdown_label')}
              </label>
              <div className="relative">
                <select
                  value={selectedCategory}
                  onChange={handleDropdownChange}
                  className="w-full appearance-none bg-white/15 backdrop-blur-sm border border-white/25 text-white rounded-xl px-5 py-3.5 pr-12 text-sm cursor-pointer focus:outline-none focus:border-white/50 transition-all"
                >
                  <option value="" className="text-foreground-700 bg-white">{t('dropdown_label')}</option>
                  {categories.map((cat) => (
                    <option key={cat.key} value={cat.url} className="text-foreground-700 bg-white">
                      {cat.name}
                    </option>
                  ))}
                </select>
                <i className="ri-arrow-down-s-line absolute right-4 top-1/2 -translate-y-1/2 text-white/70 pointer-events-none text-lg"></i>
              </div>
            </div>
          </div>

          <div className="flex-1 w-full hidden lg:block">
            <div className="relative w-full h-[500px] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20curated%20product%20collage%20of%20fashion%20items%20including%20sneakers%20hoodies%20bags%20accessories%20on%20light%20cream%20background%2C%20minimal%20scandinavian%20editorial%20style%2C%20soft%20warm%20natural%20lighting%2C%20clean%20composition%20with%20ample%20negative%20space%2C%20modern%20aesthetic%2C%20no%20text%20no%20watermark&width=800&height=1000&seq=hero-side-02&orientation=portrait"
                alt="YOYBUY Sheet — товары из Китая"
                className="w-full h-full object-cover rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}